
import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Title, Video} from './../../Basics';

const Particle03 = () => (<div>

  <Title>From rehab to Cybathlon</Title>
  <Paragraph>
    A motorcycle accident two years ago left Florian Hauser, 27, paralyzed from the chest downwards.
    During his rehabilitation in the Swiss Paraplegic Centre in Nottwil, a caregiver approached him and
    explained that her brother was working on an exciting project at the Hochschule Rapperswil. She went
    on to tell him that the team was looking for a pilot for the wheelchair race during the Cybathlon.
    Would Florian be interested in participating? He immediately agreed. In the film, he relates how he
    trained for the competition and describes his ideal wheelchair.
  </Paragraph>

  <Video
    source={require('./03 Florian Hauser EN.mp4')}
    poster={require('./03_Interview_Florian_Hauser.png')}
  />

   <Particle
    number={7}
  />

  <Particle
    number={5}
  />

</div>);

export default Particle03;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle03/Particle03_EN.js
 **/